<p>{{ 'PercentComplete' | translate:progressPrecent }}</p>
<soho-progress [progressValue]="progressValue"></soho-progress>
